export default "__VITE_ASSET__CXVBplES__"